import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  HostListener,
  ElementRef,
} from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

interface FilteredDataElement {
  filters: any;
}

export enum constants {
  'LIST' = 'list',
  'DATE' = 'date',
  'AMOUNT' = 'amount'
}

@Component({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatSelectModule,
        MatInputModule,
        MatFormFieldModule,
        MatRadioModule,
        MatChipsModule,
        MatDatepickerModule,
        MatNativeDateModule,
    ],
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {
  @Input() filterData = [];
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Input() filteredData: FilteredDataElement = {
    filters: {},
  };
  @Input() noOfFilters: number;
  @Input() continInputValue: string;
  isClicked = false;
  hoverActive = false;
  seeAllClickedName;
  selectedItem: any;
  selected = 0;
  originalData = [];
  itemIndex = 0;
  filterForm: UntypedFormGroup;
  amountOperators = [
    { value: 'equals', label: 'Equals (=)' },
    { value: 'greater_than', label: 'Greater Than (>)' },
    { value: 'less_than', label: 'Less Than (<)' },
    { value: 'greater_than_equal', label: 'Greater Than or Equal (>=)' },
    { value: 'less_than_equal', label: 'Less Than or Equal (<=)' },
    { value: 'between', label: 'Between' }
  ];
  impressionCountOperators = [
    { value: 'equals', label: 'Equals (=)' },
    { value: 'greater_than', label: 'Greater Than (>)' },
    { value: 'less_than', label: 'Less Than (<)' },
    { value: 'greater_than_equal', label: 'Greater Than or Equal (>=)' },
    { value: 'less_than_equal', label: 'Less Than or Equal (<=)' },
    { value: 'between', label: 'Between' }
  ];
  passPercentageOperators = [
    { value: 'equals', label: 'Equals (=)' },
    { value: 'greater_than', label: 'Greater Than (>)' },
    { value: 'less_than', label: 'Less Than (<)' },
    { value: 'greater_than_equal', label: 'Greater Than or Equal (>=)' },
    { value: 'less_than_equal', label: 'Less Than or Equal (<=)' },
    { value: 'between', label: 'Between' }
  ];
  tatOperators = [
    { value: 'equals', label: 'Equals (=)' },
    { value: 'greater_than', label: 'Greater Than (>)' },
    { value: 'less_than', label: 'Less Than (<)' },
    { value: 'greater_than_equal', label: 'Greater Than or Equal (>=)' },
    { value: 'less_than_equal', label: 'Less Than or Equal (<=)' },
    { value: 'between', label: 'Between' }
  ];

  isTatBetweenOperator(): boolean {
    const currentTatControl = this.getCurrentTatControl();
    return currentTatControl?.get('operator')?.value === 'between';
  }

  getCurrentTatControl(): any {
    if (!this.selectedItem) return null;
    const tatGroup = this.filterForm.get('tatInputs') as FormGroup;
    return tatGroup.get(this.selectedItem.dataKeyName);
  }
  isPassPercentageBetweenOperator(): boolean {
    const currentPassPercentageControl = this.getCurrentPassPercentageControl();
    return currentPassPercentageControl?.get('operator')?.value === 'between';
  }

  getCurrentPassPercentageControl(): any {
    if (!this.selectedItem) return null;
    const passPercentageGroup = this.filterForm.get('passPercentageInputs') as FormGroup;
    return passPercentageGroup.get(this.selectedItem.dataKeyName);
  }


  searchDetails = { defaultValue: [], searchValue: [] };
  @ViewChild('filterContainer') filterContainer: ElementRef; // Reference to the filter container
  numberOperators = [
    { value: 'equals', label: 'Equals (=)' },
    { value: 'greater_than', label: 'Greater Than (>)' },
    { value: 'less_than', label: 'Less Than (<)' },
    { value: 'greater_than_equal', label: 'Greater Than or Equal (>=)' },
    { value: 'less_than_equal', label: 'Less Than or Equal (<=)' },
    { value: 'between', label: 'Between' }
  ];
  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(null),
  });
  readonly constants: typeof constants = constants;

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit(): void {
    console.log('filterData', this.filteredData);
    this.originalData = JSON.parse(JSON.stringify(this.filterData));
    console.log('this.originalData', this.filterData);
    this.selectedItem = this.filterData[0];
    const startDate = new Date(new Date().setDate(new Date().getDate() - 30));
    const endDate = new Date();

    const inputGroup = {};
    this.filterData.forEach(item => {
      if (item.type === 'static') {
        inputGroup[item.dataKeyName] = this.fb.array([]);
      }
      if (item.type === 'amount') {
        inputGroup[item.dataKeyName] = this.fb.group({
          operator: ['equals'],
          value: [null],
          start: [null],
          end: [null]
        });
      }
      if (item.type === 'impression_count') {
        inputGroup[item.dataKeyName] = this.fb.group({
          operator: ['equals'],
          value: [null],
          start: [null],
          end: [null]
        });
      }
      if (item.type === 'pass_percentage') {
        inputGroup[item.dataKeyName] = this.fb.group({
          operator: ['equals'],
          value: [50], 
          start: [30], 
          end: [70]    
        });
      }
      if (item.type === 'tat_days') {
        inputGroup[item.dataKeyName] = this.fb.group({
          operator: ['equals'],
          value: [null],
          start: [null],
          end: [null]
        });
      }
    });

    this.filterForm = this.fb.group({
      option: [''],
      start: [startDate],
      end: [endDate],
      value: [''],
      isValue: [''],
      containsValue: [''],
      tagKey: [''],
      tagValue: [''],
      tagFilters: this.fb.array([]),
      tags: this.fb.group({}),
      search: [''],
      statusTags: this.fb.array([]),
      staticInputs: this.fb.group(inputGroup),
      amountInputs: this.fb.group(inputGroup),
      impressionCountInputs: this.fb.group(inputGroup),
      passPercentageInputs: this.fb.group(inputGroup),
      tatInputs: this.fb.group(inputGroup)
    });

    this.range = new FormGroup({
      start: new FormControl(startDate),
      end: new FormControl(endDate),
    });
  }
  get tagFilters(): FormArray {
    return this.filterForm.get('tagFilters') as FormArray;
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    // Check if the click is outside the filter container and not on date picker or filter content
    if (!this.isClicked) return;
    const inContainer = this.filterContainer.nativeElement.contains(event.target);
    const inDatePicker = this.isDatePicker(event.target);
    const inFilterContent = this.isFilterContent(event.target);
    if (!inContainer && !inDatePicker && !inFilterContent) {
      this.isClicked = false; // Close the filter box
    }
  }
  isImpressionCountBetweenOperator(): boolean {
    const currentImpressionCountControl = this.getCurrentImpressionCountControl();
    return currentImpressionCountControl?.get('operator')?.value === 'between';
  }

  getCurrentImpressionCountControl(): any {
    if (!this.selectedItem) return null;
    const impressionCountGroup = this.filterForm.get('impressionCountInputs') as FormGroup;
    return impressionCountGroup.get(this.selectedItem.dataKeyName);
  }
  isFilterContent(target: EventTarget): boolean {
    const filterContentSelectors = [
      '.mat-select-panel',
      '.mat-option',
      '.mat-form-field',
      '.mat-input-element',
      '.mat-radio-button',
      '.mat-checkbox',
      '.mat-datepicker-content',
      '.mat-calendar',
      '.mat-datepicker-toggle'
    ];

    return filterContentSelectors.some(selector => {
      const elements = document.querySelectorAll(selector);
      return Array.from(elements).some(element => element.contains(target as Node));
    });
  }
  handleMaterialClick(event: Event) {
    event.stopPropagation();
  }

  isBetweenOperator(): boolean {
    const currentAmountControl = this.getCurrentAmountControl();
    return currentAmountControl?.get('operator')?.value === 'between';
  }
  getCurrentAmountControl(): any {
    if (!this.selectedItem) return null;
    const amountGroup = this.filterForm.get('amountInputs') as FormGroup;
    return amountGroup.get(this.selectedItem.dataKeyName);
  }


  isDatePicker(target: EventTarget): boolean {
    const node = target as Node;

    if (!document.contains(node)) {
      return true;
    }

    const datePickerElements = [
      '.mat-datepicker-content',
      '.mat-calendar',
      '.mat-datepicker-toggle',
      '.cdk-overlay-container',
      '.cdk-overlay-pane',
    ];
    return datePickerElements.some(datePickerElements =>
      Array.from(document.querySelectorAll(datePickerElements)).some(element => element.contains(node))
    );
  }
  seeAllHandler(event, name, list) {
    event.stopPropagation();
    this.seeAllClickedName = name;
    this.searchDetails.defaultValue = list;
    this.searchDetails.searchValue = list;
  }

  searchHandler(search) {
    this.searchDetails.searchValue = this.searchDetails.defaultValue.filter(
      (element) => {
        return element.toLowerCase().includes(search.toLowerCase());
      }
    );
  }

  addTagFilter() {
    const key = this.filterForm.get('tagKey')?.value?.trim();
    const value = this.filterForm.get('tagValue')?.value?.trim();

    if (!key || !value) return;

    this.tagFilters.push(
      this.fb.group({
        key: [key],
        value: [value]
      })
    );

    this.filterForm.patchValue({ tagKey: '', tagValue: '' });
  }
  removeTagFilter(index: number) {
    this.tagFilters.removeAt(index);
  }

  checkboxHandler(event, isClicked, item, parent) {
    event.stopPropagation();

    console.log('disturbance', event, isClicked, item, parent)

    // Initialize tags if not already initialized
    if (!this.filterForm.value.tags) {
      this.filterForm.value.tags = {};
    }

    // Initialize the parent.dataKeyName array if not already initialized
    if (!this.filterForm.value.tags[parent.dataKeyName]) {
      this.filterForm.value.tags[parent.dataKeyName] = [];
    }

    if (isClicked) {
      // Add the item to the selected tags
      this.filterForm.value.tags[parent.dataKeyName].push(item);
    } else {
      // Remove the item from the selected tags
      this.filterForm.value.tags[parent.dataKeyName] = this.filterForm.value.tags[parent.dataKeyName].filter(
        (element) => element !== item
      );
    }
  }

  containerHandler(event: Event) {
    event.stopPropagation();
    this.seeAllClickedName = null;
  }

  searchMenuHandler(event: Event) {
    event.stopPropagation();
  }

  filterClickHandler(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.isClicked = !this.isClicked;

    console.log('currentSelected', this.selectedItem);

    // If opening the filter modal, reset the current filter form
    if (this.isClicked && this.selectedItem) {
      const appliedFilters = this.filteredData?.filters || {};
      const currentFilter = appliedFilters[this.selectedItem.dataKeyName] || appliedFilters[this.selectedItem.type];

      if (currentFilter) {
        // Initialize form with applied filter
        this.toggleDropdown(this.selectedItem, this.selected); // reuse existing logic
      } else {
        // No applied filter, reset current filter form
        this.resetCurrentFilterForm();
      }
    }
  }

  clearFilter(type: string) {
    this.filterForm.reset();
    const statusTags = this.filterForm.get('statusTags') as FormArray;
    while (statusTags.length) {
      statusTags.removeAt(0);
    }

    this.filterForm.patchValue({
      numberOperator: 'equals',
      numberValue: null,
      numberStart: null,
      numberEnd: null
    });
    // re-create empty staticInputs arrays to avoid missing controls
    const staticInputsGroup = {};
    this.filterData.forEach(item => {
      if (item.type === 'static') {
        staticInputsGroup[item.dataKeyName] = this.fb.array([]);
      }
    });
    if (type === 'impression_count') {
      const impressionCountGroup = this.filterForm.get('impressionCountInputs') as FormGroup;
      const currentControl = impressionCountGroup.get(this.selectedItem.dataKeyName);
      if (currentControl) {
        currentControl.patchValue({
          operator: 'equals',
          value: null,
          start: null,
          end: null
        });
      }

      this.onSelect.emit({
        type: 'clear',
        datakey: this.selectedItem?.dataKeyName || '',
        name: this.selectedItem?.name || '',
        clearType: type
      });
      return;
    }
    if (type === 'amount') {
      const amountGroup = this.filterForm.get('amountInputs') as FormGroup;
      const currentControl = amountGroup.get(this.selectedItem.dataKeyName);
      if (currentControl) {
        currentControl.patchValue({
          operator: 'equals',
          value: null,
          start: null,
          end: null
        });
      }

      this.onSelect.emit({
        type: 'clear',
        datakey: this.selectedItem?.dataKeyName || '',
        name: this.selectedItem?.name || '',
        clearType: type
      });
      return;
    }

    this.filterForm.setControl('staticInputs', this.fb.group(staticInputsGroup));
    this.filterForm.setControl('tagFilters', this.fb.array([]));

    this.filterForm.patchValue({ tags: {}, statusValue: null });

    if (type === constants.DATE) {
      this.range.reset();
    } else if (type === constants.LIST) {
      this.selectedItem.data = this.originalData[this.selected].data;
    }

    // Emit a clear event to the table component
    this.onSelect.emit({
      type: 'clear',
      datakey: this.selectedItem?.dataKeyName || '',
      name: this.selectedItem?.name || '',
      clearType: type
    });
  }

  applyFilter(type: string, datakey: string, name: string) {
    // Get the selected option (is or contains)
    const selectedOption = this.filterForm.value.option;

    // Get the value based on the selected option
    let value = '';
    if (selectedOption === 'is') {
      value = this.filterForm.value.isValue;
    } else if (selectedOption === 'contains') {
      value = this.filterForm.value.containsValue;
    }

    console.log('selectedOption', selectedOption, 'value', value);

    // For list & static, emit selected values from staticInputs
    if (type === 'static') {
      const arr = this.filterForm.get(`staticInputs.${datakey}`) as FormArray;
      this.onSelect.emit({
        type,
        datakey,
        name,
        value: arr ? arr.value : []
      });
      this.filterClickHandler();
      return;
    }

    if (type === 'list') {
      const pendingKey = this.filterForm.get('tagKey')?.value?.trim();
      const pendingValue = this.filterForm.get('tagValue')?.value?.trim();
      if (pendingKey && pendingValue) {
        this.addTagFilter();
      }
      console.log('this.tagFilters.value', this.tagFilters.value);
      this.onSelect.emit({
        type,
        datakey,
        name,
        value: this.tagFilters.value
      });
      return this.filterClickHandler();
    }
    if (type === 'tat_days') {
      const tatGroup = this.filterForm.get('tatInputs') as FormGroup;
      const tatControl = tatGroup.get(datakey);

      if (tatControl) {
        const operatorData = tatControl.value;

        this.onSelect.emit({
          type: 'tat_days',
          datakey: datakey,
          name: name,
          operator: operatorData.operator,
          value: operatorData.value,
          start: operatorData.start,
          end: operatorData.end
        });
      }
      this.filterClickHandler();
      return;
    }
    if (type === 'pass_percentage') {
      const passPercentageGroup = this.filterForm.get('passPercentageInputs') as FormGroup;
      const passPercentageControl = passPercentageGroup.get(datakey);

      if (passPercentageControl) {
        const operatorData = passPercentageControl.value;

        this.onSelect.emit({
          type: 'pass_percentage',
          datakey: datakey,
          name: name,
          operator: operatorData.operator,
          value: operatorData.value,
          start: operatorData.start,
          end: operatorData.end
        });
      }
      this.filterClickHandler();
      return;
    }
    if (type === 'amount') {
      const amountGroup = this.filterForm.get('amountInputs') as FormGroup;
      const amountControl = amountGroup.get(datakey);

      if (amountControl) {
        const operatorData = amountControl.value;

        this.onSelect.emit({
          type: 'amount',
          datakey: datakey,
          name: name,
          operator: operatorData.operator,
          value: operatorData.value,
          start: operatorData.start,
          end: operatorData.end
        });
      } else {
      }
      this.filterClickHandler();
      return;
    }
    if (type === 'impression_count') {
      const impressionCountGroup = this.filterForm.get('impressionCountInputs') as FormGroup;
      const impressionCountControl = impressionCountGroup.get(datakey);

      if (impressionCountControl) {
        const operatorData = impressionCountControl.value;

        this.onSelect.emit({
          type: 'impression_count',
          datakey: datakey,
          name: name,
          operator: operatorData.operator,
          value: operatorData.value,
          start: operatorData.start,
          end: operatorData.end
        });
      }
      this.filterClickHandler();
      return;
    }
    if (type === 'status') {
      const selectedStatuses = this.filterForm.value.statusTags || [];

      this.onSelect.emit({
        type,
        datakey,
        name,
        value: selectedStatuses
      });

      this.filterClickHandler();
      return;
    }

    // Emit the filter data
    this.onSelect.emit({
      type,
      datakey,
      name,
      option: selectedOption,
      value,
      ...this.filterForm.value,
    });

    // Close the filter box
    this.filterClickHandler();
  }
  onInputChange(event: any) {
    try {
      console.log('Input change event:', event);

      // Get search value safely
      const searchValue = (event?.target?.value || event || '').toString().toLowerCase();
      console.log('Search value:', searchValue);


      // Only proceed if we have a selected item of type 'list'
      if (!this.selectedItem || this.selectedItem.type !== 'list') {
        console.warn('No selected item or not a list type');
        return;
      }

      console.log('Original data:', this.originalData);
      console.log('Selected index:', this.selected);

      // Get the source data - first try selectedItem.data, then fallback to originalData
      let sourceData = this.selectedItem.data ||
        (this.originalData[this.selected]?.data || []);

      if (!Array.isArray(sourceData)) {
        console.error('Source data is not an array, defaulting to empty array');
        sourceData = [];
      }

      console.log('Source data before filter:', sourceData);

      // Perform the filter
      this.selectedItem.data = sourceData.filter(item =>
        item?.toString().toLowerCase().includes(searchValue)
      );

      console.log('Filtered data:', this.selectedItem.data);
    } catch (error) {
      console.error('Error during search:', error);
      this.selectedItem.data = [];
    }
  }

  isAnyFilterSelected(): boolean {
    if (this.selectedItem?.type === 'amount') {
      const amountGroup = this.filterForm.get('amountInputs') as FormGroup;
      const amountControl = amountGroup.get(this.selectedItem.dataKeyName);
      if (amountControl) {
        const { operator, value, start, end } = amountControl.value;
        if (operator === 'between') {
          return !!(start !== null && start !== '' && end !== null && end !== '');
        } else {
          return !!(value !== null && value !== '');
        }
      }
    }
    if (this.selectedItem?.type === 'impression_count') {
      const impressionCountGroup = this.filterForm.get('impressionCountInputs') as FormGroup;
      const impressionCountControl = impressionCountGroup.get(this.selectedItem.dataKeyName);
      if (impressionCountControl) {
        const { operator, value, start, end } = impressionCountControl.value;
        if (operator === 'between') {
          return !!(start !== null && start !== '' && end !== null && end !== '');
        } else {
          return !!(value !== null && value !== '');
        }
      }
    }
    if (this.selectedItem?.type === 'tat_days') {
      const tatGroup = this.filterForm.get('tatInputs') as FormGroup;
      const tatControl = tatGroup.get(this.selectedItem.dataKeyName);
      if (tatControl) {
        const { operator, value, start, end } = tatControl.value;
        if (operator === 'between') {
          return !!(start !== null && start !== '' && end !== null && end !== '');
        } else {
          return !!(value !== null && value !== '');
        }
      }
    }
    if (this.selectedItem?.type === 'pass_percentage') {
      const passPercentageGroup = this.filterForm.get('passPercentageInputs') as FormGroup;
      const passPercentageControl = passPercentageGroup.get(this.selectedItem.dataKeyName);
      if (passPercentageControl) {
        const { operator, value, start, end } = passPercentageControl.value;
        if (operator === 'between') {
          return !!(start !== null && start !== '' && end !== null && end !== '');
        } else {
          return !!(value !== null && value !== '');
        }
      }
    }
    //For status filter
    if (this.selectedItem?.type === 'status') {
      const statusTags = this.filterForm.get('statusTags') as FormArray;
      if (statusTags && statusTags.value.length > 0) return true;
    }

    //For static filters
    if (this.selectedItem?.type === 'static') {
      const arr = this.filterForm.get(`staticInputs.${this.selectedItem.dataKeyName}`) as FormArray;
      if (arr && arr.value.length > 0) return true;
    }

    // For list filters (checkboxes)
    if (this.selectedItem?.type === 'list') {
      const hasPending = !!(this.filterForm.get('tagKey')?.value?.trim() && this.filterForm.get('tagValue')?.value?.trim());
      return (this.tagFilters?.length > 0) || hasPending;
    }
    // For number filters
    if (this.selectedItem?.type === 'number') {
      if (this.filterForm.value.isValue || (this.filterForm.value.start && this.filterForm.value.end)) return true;
    }
    // For text filters
    if (this.selectedItem?.type === 'text') {
      if ((this.filterForm.value.isValue && this.filterForm.value.option === 'is') ||
        (this.filterForm.value.containsValue && this.filterForm.value.option === 'contains')) return true;
    }
    // For date filters
    if (this.selectedItem?.type === 'date') {
      if ((this.filterForm.value.start && this.filterForm.value.option === 'is') ||
        (this.filterForm.value.start && this.filterForm.value.end && this.filterForm.value.option === 'between')) return true;
    }
    // For all text
    if (this.selectedItem?.type === 'all') {
      if (this.filterForm.value.value && this.filterForm.value.value.trim().length > 0) return true;
    }
    return false;
  }

  statusCheckboxHandler(event: Event, item: string) {
    const checked = (event.target as HTMLInputElement).checked;
    const statusTags = this.filterForm.get('statusTags') as FormArray;
    if (checked) {
      if (!statusTags.value.includes(item)) {
        statusTags.push(this.fb.control(item));
      }
    } else {
      const index = statusTags.value.indexOf(item);
      if (index >= 0) statusTags.removeAt(index);
    }
  }

  isStatusSelected(item: string): boolean {
    const statusTags = this.filterForm.get('statusTags') as FormArray;
    console.log('statusTags', statusTags.value)
    return statusTags.value.includes(item);
  }

  // For static type checkboxes (rewired to staticInputs)
  staticCheckboxHandler(event: Event, item: string) {
    event.stopPropagation();
    console.log('Static checkbox event:', event, 'item:', item);
    const key = this.selectedItem?.dataKeyName;
    const arr = this.filterForm.get(`staticInputs.${key}`) as FormArray;
    if (!arr) return;
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      if (!arr.value.includes(item)) arr.push(this.fb.control(item));
    } else {
      const i = arr.value.indexOf(item);
      if (i !== -1) arr.removeAt(i);
    }
  }

  isStaticSelected(item: string): boolean {
    const key = this.selectedItem?.dataKeyName;
    const arr = this.filterForm.get(`staticInputs.${key}`) as FormArray;
    return !!arr && arr.value.includes(item);
  }

  toggleDropdown(filter, index) {
    this.selectedItem = filter;
    this.selected = index;

    const appliedFilters = this.filteredData?.filters || {};
    const currentFilter = appliedFilters[filter.dataKeyName] || appliedFilters[filter.type];
    console.log(filter, 'currentFilter', currentFilter, this.filteredData?.filters)

    if (currentFilter) {
      // Initialize the form based on the type of the current filter
      switch (currentFilter.type) {
        case 'pass_percentage':
          const passPercentageGroup = this.filterForm.get('passPercentageInputs') as FormGroup;

          if (!passPercentageGroup.get(filter.dataKeyName)) {
            passPercentageGroup.addControl(filter.dataKeyName, this.fb.group({
              operator: ['equals'],
              value: [50], 
              start: [30], 
              end: [70]    
            }));
          }

          const passPercentageControl = passPercentageGroup.get(filter.dataKeyName);
          if (passPercentageControl) {
            passPercentageControl.patchValue({
              operator: currentFilter.operator || 'equals',
              value: currentFilter.value || 50, // Default 50% if no value
              start: currentFilter.start || 30, // Default 30% if no start
              end: currentFilter.end || 70      // Default 70% if no end
            });
          }
          break;
        case 'tat_days':
          const tatGroup = this.filterForm.get('tatInputs') as FormGroup;

          if (!tatGroup.get(filter.dataKeyName)) {
            tatGroup.addControl(filter.dataKeyName, this.fb.group({
              operator: ['equals'],
              value: [null],
              start: [null],
              end: [null]
            }));
          }

          const tatControl = tatGroup.get(filter.dataKeyName);
          if (tatControl) {
            tatControl.patchValue({
              operator: currentFilter.operator || 'equals',
              value: currentFilter.value || null,
              start: currentFilter.start || null,
              end: currentFilter.end || null
            });
          }
          break;

        case 'impression_count':
          const impressionCountGroup = this.filterForm.get('impressionCountInputs') as FormGroup;

          if (!impressionCountGroup.get(filter.dataKeyName)) {
            impressionCountGroup.addControl(filter.dataKeyName, this.fb.group({
              operator: ['equals'],
              value: [null],
              start: [null],
              end: [null]
            }));
          }

          const impressionCountControl = impressionCountGroup.get(filter.dataKeyName);
          if (impressionCountControl) {
            impressionCountControl.patchValue({
              operator: currentFilter.operator || 'equals',
              value: currentFilter.value || null,
              start: currentFilter.start || null,
              end: currentFilter.end || null
            });
          }
          break;
        case 'amount':
          const amountGroup = this.filterForm.get('amountInputs') as FormGroup;

          if (!amountGroup.get(filter.dataKeyName)) {
            amountGroup.addControl(filter.dataKeyName, this.fb.group({
              operator: ['equals'],
              value: [null],
              start: [null],
              end: [null]
            }));
          }

          const amountControl = amountGroup.get(filter.dataKeyName);
          if (amountControl) {
            amountControl.patchValue({
              operator: currentFilter.operator || 'equals',
              value: currentFilter.value !== null && currentFilter.value !== undefined ? currentFilter.value : null,
              start: currentFilter.start !== null && currentFilter.start !== undefined ? currentFilter.start : null,
              end: currentFilter.end !== null && currentFilter.end !== undefined ? currentFilter.end : null
            });
          }
          break;

        case 'number_operator':
          this.filterForm.patchValue({
            numberOperator: currentFilter.operator || 'equals',
            numberValue: currentFilter.value || null,
            numberStart: currentFilter.start || null,
            numberEnd: currentFilter.end || null
          });
          break;

        case 'date':
          this.filterForm.patchValue({
            option: currentFilter.option || '',
            start: currentFilter.start ? new Date(currentFilter.start) : null,
            end: currentFilter.end ? new Date(currentFilter.end) : null,
          });
          this.range.patchValue({
            start: currentFilter.start ? new Date(currentFilter.start) : null,
            end: currentFilter.end ? new Date(currentFilter.end) : null,
          });
          break;

        case 'list':
          const tagFiltersArray = this.filterForm.get('tagFilters') as FormArray;
          while (tagFiltersArray.length) {
            tagFiltersArray.removeAt(0);
          }
          if (Array.isArray(currentFilter.value)) {
            currentFilter.value.forEach(tag => {
              tagFiltersArray.push(
                this.fb.group({
                  key: [tag.key || ''],
                  value: [tag.value || '']
                })
              );
            });
          }
          break;

        case 'status':
          const statusArray = this.filterForm.get('statusTags') as FormArray;
          while (statusArray.length) {
            statusArray.removeAt(0);
          }
          if (currentFilter.value && Array.isArray(currentFilter.value)) {
            currentFilter.value.forEach(val => statusArray.push(this.fb.control(val)));
          }
          break;

        case 'static':
          const key = currentFilter.datakey || currentFilter.datakey || filter.dataKeyName;
          const staticGroup = this.filterForm.get('staticInputs') as FormGroup;
          if (!staticGroup.get(key)) {
            staticGroup.addControl(key, this.fb.array([]));
          }
          const arr = this.filterForm.get(`staticInputs.${key}`) as FormArray;
          while (arr && arr.length) arr.removeAt(0);
          if (currentFilter.value && Array.isArray(currentFilter.value)) {
            currentFilter.value.forEach(v => arr.push(this.fb.control(v)));
          }
          break;

        case 'text':
          this.filterForm.patchValue({
            option: currentFilter.option || '',
            isValue: currentFilter.isValue || (currentFilter.option === 'is' ? currentFilter.value : '') || '',
            containsValue: currentFilter.containsValue || (currentFilter.option === 'contains' ? currentFilter.value : '') || '',
          });
          break;

        case 'number':
          this.filterForm.patchValue({
            option: currentFilter.option || '',
            isValue: currentFilter.isValue || '',
            start: currentFilter.start || '',
            end: currentFilter.end || '',
          });
          break;

        case 'all':
          this.filterForm.patchValue({
            value: currentFilter.value || '',
          });
          break;

        default:
          this.resetCurrentFilterForm();
      }
    } else {
      this.resetCurrentFilterForm();
    }
  }

  // Helper function to reset only current filter fields
  resetCurrentFilterForm() {
    const statusArray = this.filterForm.get('statusTags') as FormArray;
    while (statusArray.length) {
      statusArray.removeAt(0);
    }

    // reset all staticInputs arrays
    const staticGroup = this.filterForm.get('staticInputs') as FormGroup;
    if (staticGroup) {
      Object.keys(staticGroup.controls).forEach(k => {
        const arr = staticGroup.get(k) as FormArray;
        while (arr && arr.length) arr.removeAt(0);
      });
    }

    this.filterForm.patchValue({
      option: '',
      start: null,
      end: null,
      value: '',
      isValue: '',
      containsValue: '',
      tags: {},
      numberOperator: 'equals',
      numberValue: null,
      numberStart: null,
      numberEnd: null
    });
  }
  formatLabel(value: number): string {
    return `${value}%`;
  }

  isFilterApplied(filter): boolean {
    const appliedFilters = this.filteredData?.filters || {};

    switch (filter.type) {
      case 'pass_percentage':
        const passPercentageFilter = appliedFilters[filter.dataKeyName];
        if (!passPercentageFilter) return false;

        if (passPercentageFilter.operator === 'between') {
          return !!(passPercentageFilter.start !== null && passPercentageFilter.start !== '' &&
            passPercentageFilter.end !== null && passPercentageFilter.end !== '');
        } else {
          return !!(passPercentageFilter.value !== null && passPercentageFilter.value !== '');
        }

      case 'impression_count':
        const impressionCountFilter = appliedFilters[filter.dataKeyName];

        if (!impressionCountFilter) return false;

        if (impressionCountFilter.operator === 'between') {
          const result = !!(impressionCountFilter.start !== null && impressionCountFilter.start !== '' &&
            impressionCountFilter.end !== null && impressionCountFilter.end !== '');
          return result;
        } else {
          const result = !!(impressionCountFilter.value !== null && impressionCountFilter.value !== '');
          return result;
        }
      case 'tat_days':
        const tatFilter = appliedFilters[filter.dataKeyName];
        if (!tatFilter) return false;

        if (tatFilter.operator === 'between') {
          return !!(tatFilter.start !== null && tatFilter.start !== '' &&
            tatFilter.end !== null && tatFilter.end !== '');
        } else {
          return !!(tatFilter.value !== null && tatFilter.value !== '');
        }
      case 'amount':
        const amountFilter = appliedFilters[filter.dataKeyName];
        if (!amountFilter) return false;

        if (amountFilter.operator === 'between') {
          return !!(amountFilter.start !== null && amountFilter.start !== '' &&
            amountFilter.end !== null && amountFilter.end !== '');
        } else {
          return !!(amountFilter.value !== null && amountFilter.value !== '');
        }

      case 'status':
        return appliedFilters[filter.type]?.value?.length > 0;

      case 'list':
        return (
          appliedFilters[filter.dataKeyName]?.tags?.[filter.dataKeyName]?.length > 0
        );

      case 'static':
        return appliedFilters[filter.dataKeyName]?.value?.length > 0;

      case 'text':
      case 'number':
      case 'date':
      case 'all':
        const f = appliedFilters[filter.dataKeyName] || appliedFilters[filter.type];
        if (!f) return false;

        if (filter.type === 'text' || filter.type === 'all') {
          return !!f.isValue || !!f.containsValue || !!f.value;
        }
        if (filter.type === 'number' || filter.type === 'date') {
          return !!f.start || !!f.end || !!f.isValue;
        }
        return false;

      default:
        return false;
    }
  }

}